import store from "./store";

export default {
    async show (text, title) {
        return new Promise(resolve => {
            store.commit("mutate", {
                modal: {
                    text: text,
                    title: title || "Confirm action",
                    active: true,
                    resolve: resolve
                }
            });
        });
    },
    hide (result) {
        store.state.modal.resolve(result);
        store.commit("mutate", {
            modal: {
                active: false,
                resolve: null
            }
        });
    },
    cancel() { this.hide(false) },
    ok() { this.hide(true) },
};